<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato Locomotore" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Atteggiamenti e Decubito:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoLocomotore.atteggiamentiDecubito }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoLocomotore.atteggiamentiDecubito" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Sviluppo Scheletro:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoLocomotore.sviluppoScheletro }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoLocomotore.sviluppoScheletro" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Morfologia delle singole parti:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoLocomotore.morfologiaSingoleParti }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoLocomotore.morfologiaSingoleParti" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataApparatoLocomotore.id" @click="onSalvaApparatoLocomotore"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoLocomotore: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    atteggiamentiDecubito: "",
                    morfologiaSingoleParti: "",
                    sviluppoScheletro: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoLocomotore: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoLocomotore: "/rsaschedarelazionesanitariaapparatolocomotore",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoLocomotore() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoLocomotore + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoLocomotoreSuccess, me.resultResponseSchedaRelazioneSanitariaApparatoLocomotoreError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoLocomotoreSuccess(response) {
            let me = this;
            me.jsonDataApparatoLocomotore = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoLocomotoreError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoLocomotore = {
                atteggiamentiDecubito: "",
                morfologiaSingoleParti: "",
                sviluppoScheletro: "",
            };
        },

        onSalvaApparatoLocomotore() {
            let me = this;
            me.jsonDataApparatoLocomotore.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoLocomotore.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoLocomotore, me.jsonDataApparatoLocomotore, me.saveSchedaRelazioneSanitariaApparatoLocomotoreSuccessResponse, me.saveSchedaRelazioneSanitariaApparatoLocomotoreErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoLocomotoreSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Apparato locomotore salvato con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaApparatoLocomotoreErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato locomotore:");
        },
    },
};
</script>
